import React, { useState, useRef } from "react";
import { Redirect, useLocation, useHistory, useParams } from "react-router-dom";

import Gelombang from "../../../assets/images/login-gelombang.svg";
import ImageFamily from "../../../assets/images/family.svg";

import {
  Button,
  FormHelperText,
  CircularProgress,
  Grid,
  TextField,
} from "@material-ui/core";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";

import PageLoading from "../../../components/appLoading";
import useStyles from "./styles";
import Header from "../../../components/molecules/navbarLogReg";
import Header1 from "../../../components/molecules/LoginNav/header";

import Footer from "../../../components/molecules/LoginNav/footer";
import useCountDownTimer from "../../../components/useCountDownTimer/index.js";

import {
  auth,
  firefunctions,
  useFirebase,
} from "../../../components/firebase/FirebaseProvider";

function KirimUlang({ expired_at, requestOTP }) {
  const { timerArray, seconds } = useCountDownTimer(expired_at);
  const { enqueueSnackbar } = useSnackbar();
  const reRequestOTP = async () => {
    await requestOTP();
    enqueueSnackbar("6  digit kode baru berhasil dikirim ulang!", {
      variant: "success",
    });
  };

  return (
    <Button
      style={{
        color: "#5675D3",
        fontSize: 12,
        backgroundColor: "transparent",
        textTransform: "capitalize",
      }}
      disabled={seconds > 0}
      onClick={reRequestOTP}
    >
      {seconds > 0
        ? `Kirim Ulang (${timerArray[1]}:${timerArray[2]})`
        : "Kirim Ulang"}
    </Button>
  );
}

const OTP = () => {
  const classes = useStyles();
  const [year] = useState(new Date().getFullYear());
  const theme = useTheme();
  const history = useHistory();
  const matches = useMediaQuery(theme.breakpoints.up("tablet"));
  const location = useLocation();

  const { loading, user } = useFirebase();
  const { phone, expired } = useParams();

  const [isSubmitting, setSubmitting] = useState(false);
  const [autoSubmit, setAutoSubmit] = useState(true);
  const [expired_at, setExpiredAt] = useState(0);

  const [values, setValues] = useState({
    one: "",
    two: "",
    three: "",
    four: "",
    five: "",
    six: "",
  });
  const [error, setError] = useState({});

  let two = useRef(null);
  let three = useRef(null);
  let four = useRef(null);
  let five = useRef(null);
  let six = useRef(null);

  const requestOTP = async (e) => {
    setSubmitting(true);
    try {
      setValues({
        one: "",
        two: "",
        three: "",
        four: "",
        five: "",
        six: "",
      });

      setError({
        errorStatus: false,
        errorMessage: "",
      });

      const sendOTP = firefunctions.httpsCallable("sendOTP");
      await sendOTP({ no_hp: phone });

      let expired = Date.now() + 5 * 60 * 1000;
      setExpiredAt(expired);
      history.push(`/login/forgot/${phone}/${expired}`);
    } catch (err) {
      handleError(err.message);
    }
    setSubmitting(false);
  };

  const handleChange = (prop, next) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
    });

    setError({
      errorStatus: false,
      errorMessage: "",
    });

    next.current.focus();
  };

  const handleError = (err) => {
    setError({
      errorStatus: true,
      errorMessage: err,
    });
  };

  const handleFocus = (event) => {
    event.target.select();
  };

  const validate = async () => {
    let error = "";
    if (
      !values.one ||
      !values.two ||
      !values.three ||
      !values.four ||
      !values.five ||
      !values.six
    ) {
      error = "OTP wajib diisi";
    }

    return error;
  };

  const handleSubmit = async (e) => {
    setSubmitting(true);
    setError({
      errorStatus: false,
      errorMessage: "",
    });

    if (!autoSubmit) {
      e.preventDefault();
    }

    try {
      const findErrors = await validate();
      if (findErrors) {
        throw new Error(findErrors);
      }

      let otp = [
        values.one,
        values.two,
        values.three,
        values.four,
        values.five,
        values.six,
      ].join("");

      const verifyOTP = firefunctions.httpsCallable("verifyOTP");
      const response = await verifyOTP({ no_hp: phone, otp });

      await auth.signInWithCustomToken(response?.data?.custom_token ?? "token");

      history.push("/login/reset");
      setSubmitting(false);
    } catch (err) {
      setSubmitting(false);
      handleError(err.message);
    }
    setSubmitting(false);
  };

  if (Object.values(values).every((item) => item !== "") && autoSubmit) {
    setAutoSubmit(false);
    handleSubmit();
  }

  if (loading) {
    return <PageLoading />;
  }

  if (user) {
    const redirectTo =
      location.state && location.state.from && location.state.from.pathname
        ? location.state.from.pathname
        : "/";
    return <Redirect to={redirectTo} />;
  }

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        {matches ? (
          <Header1 nameStatus={"OTP"} />
        ) : (
          <Header nameStatus={"OTP"} />
        )}

        <div className={classes.container_two}>
          <Grid container spacing={0} alignItems="center">
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              className={classes.image_background}
            >
              <img
                src={ImageFamily}
                alt="logo"
                style={{ marginLeft: "20%", width: "65%" }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} style={{ zIndex: "10" }}>
              <div className={classes.box_body}>
                <div className={classes.box_head}>
                  <div className={classes.box_head_text}>
                    <h1>Selamat Datang!</h1>
                    <p>
                      Masukkan 6 digit kode yang telah dikirmkan ke nomor{" "}
                      {phone}
                    </p>
                  </div>
                </div>
                <form
                  className={classes.box_form}
                  onSubmit={handleSubmit}
                  id="formOTP"
                >
                  <Grid
                    container
                    spacing={1}
                    style={{
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <Grid item xs={2}>
                      <TextField
                        variant="outlined"
                        onChange={handleChange("one", two)}
                        value={values.one}
                        autoFocus={true}
                        onFocus={handleFocus}
                        inputProps={{
                          style: { textAlign: "center", fontSize: 18 },
                          maxLength: 1,
                        }}
                        margin="dense"
                        error={error.errorStatus}
                        disabled={isSubmitting}
                      ></TextField>
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        variant="outlined"
                        onChange={handleChange("two", three)}
                        value={values.two}
                        onFocus={handleFocus}
                        inputProps={{
                          style: { textAlign: "center", fontSize: 18 },
                          maxLength: 1,
                        }}
                        margin="dense"
                        inputRef={two}
                        error={error.errorStatus}
                        disabled={isSubmitting}
                      ></TextField>
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        variant="outlined"
                        onChange={handleChange("three", four)}
                        value={values.three}
                        onFocus={handleFocus}
                        inputProps={{
                          style: { textAlign: "center", fontSize: 18 },
                          maxLength: 1,
                        }}
                        margin="dense"
                        inputRef={three}
                        error={error.errorStatus}
                        disabled={isSubmitting}
                      ></TextField>
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        variant="outlined"
                        onChange={handleChange("four", five)}
                        value={values.four}
                        onFocus={handleFocus}
                        inputProps={{
                          style: { textAlign: "center", fontSize: 18 },
                          maxLength: 1,
                        }}
                        margin="dense"
                        inputRef={four}
                        error={error.errorStatus}
                        disabled={isSubmitting}
                      ></TextField>
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        variant="outlined"
                        onChange={handleChange("five", six)}
                        value={values.five}
                        onFocus={handleFocus}
                        inputProps={{
                          style: { textAlign: "center", fontSize: 18 },
                          maxLength: 1,
                        }}
                        margin="dense"
                        inputRef={five}
                        error={error.errorStatus}
                        disabled={isSubmitting}
                      ></TextField>
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        variant="outlined"
                        onChange={handleChange("six", six)}
                        value={values.six}
                        onFocus={handleFocus}
                        inputProps={{
                          style: { textAlign: "center", fontSize: 18 },
                          maxLength: 1,
                        }}
                        margin="dense"
                        inputRef={six}
                        error={error.errorStatus}
                        disabled={isSubmitting}
                      ></TextField>
                    </Grid>
                  </Grid>
                  {error.errorStatus ? (
                    <FormHelperText error style={{ textAlign: "center" }}>
                      {error.errorMessage}
                    </FormHelperText>
                  ) : null}
                  <div className={classes.bottom_form}>
                    <Button
                      onClick={() => setAutoSubmit(false)}
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                      style={{
                        position: "relative",
                        width: "100%",
                        letterSpacing: "1px",
                        fontWeight: "bold",
                        borderRadius: "8px",
                        paddingTop: "12px",
                        paddingBottom: "12px",
                        marginTop: "10px",
                        marginBottom: "20px",
                      }}
                    >
                      {!isSubmitting ? (
                        "kirim"
                      ) : (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </Button>
                    <h5
                      style={{
                        color: "#00000040",
                        fontSize: matches ? "" : 17,
                        textAlign: "center",
                        marginTop: "0",
                      }}
                    >
                      Tidak mendapatkan kode?
                      <KirimUlang
                        loading={expired}
                        expired_at={expired_at === 0 ? expired : expired_at}
                        requestOTP={requestOTP}
                      />
                    </h5>
                  </div>
                </form>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className={classes.body}>
          <span className={classes.copyright} style={{ bottom: "50px" }}>
            © Hak Cipta PT. Tokorame Anugerah Sejahtera - {year}
          </span>
          <div className={classes.gelombang}>
            <img src={Gelombang} alt="gelombang" />
          </div>
        </div>
      </div>
      {matches ? <Footer /> : null}
    </div>
  );
};

export default OTP;
